<template>
  <div class="allStore">
      <iframe width="100%" height="100%" frameborder="0" scrolling="no"
        :src="'https://apis.map.qq.com/uri/v1/geocoder?coord=' + latitude + ',' + longitude + '&referer=SP7BZ-MXV6Q-LZY5O-GVGI3-II2C7-PNFFP'">
      </iframe>
      <div class="close" @click="back">
          <img src="../../assets/images/returnimg.png" alt="">
      </div>
  </div>
</template>

<script>
var _mine
export default {
  name: "",
  components: {
  },
  data() {
    return {
        latitude: '',
        longitude: ''
    }
  },
  methods: {
      back(){
          this.$router.go(-1)
      }
  },
  mounted() {
      this.latitude = this.$route.query.latitude
      this.longitude = this.$route.query.longitude
  }
};
</script>

<style scoped>
.close{
    position: fixed;
    top: 0.5rem;
    left: 10px;
    z-index: 99;
    width: 0.75rem;
    height: 0.75rem;
    opacity: 0.6;
}
.close img{
    width: 100%;
    height: 100%;
}
.allStore{
    height: 100vh;
}
</style>
